import { useId } from 'react';

/**
 * The Amari mark: a steaming bowl with a leaf on a green tile (source: scripts/brand/mark.svg,
 * which also generates the app icons and splash images). Inline, so it draws with the first paint.
 */
export function AmariMark({ size = 40, className = '' }: { size?: number; className?: string }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg viewBox="0 0 512 512" width={size} height={size} className={className} aria-hidden focusable="false">
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#7AD328" />
          <stop offset="0.5" stopColor="#0E6A14" />
          <stop offset="1" stopColor="#00360B" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="112" fill={`url(#g${id})`} />
      <g fill="#fff">
        <path d="M207 266 C 146 232 146 174 222 124 C 192 166 178 214 207 266 Z" />
        <path d="M240 242 C 218 212 222 180 250 152 C 280 122 292 84 236 42 C 274 86 266 118 238 146 C 206 178 206 212 240 242 Z" />
      </g>
      <path d="M262 287 C 246 212 318 158 422 148 C 420 234 360 286 262 287 Z" fill="#74D12A" />
      <path d="M268 284 C 296 236 336 204 386 190" fill="none" stroke="#0E6B14" strokeWidth="8" strokeLinecap="round" />
      <path d="M84 280 C 84 274 88 272 94 272 L 422 272 C 428 272 432 274 432 280 C 424 356 372 414 304 428 L 314 434 C 320 438 318 448 310 448 L 206 448 C 198 448 196 438 202 434 L 212 428 C 144 414 92 356 84 280 Z" fill="#fff" />
    </svg>
  );
}

/** The mark with the name beside it, for headers. */
export function AmariLogo({ size = 34, className = '' }: { size?: number; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <AmariMark size={size} />
      <span className="text-[28px] leading-none font-extrabold tracking-[-0.03em] font-display">Amari</span>
    </span>
  );
}
